import { render } from "./MultiVolumeBuyUpload.vue?vue&type=template&id=bff84c5c&scoped=true"
import script from "./MultiVolumeBuyUpload.vue?vue&type=script&lang=js"
export * from "./MultiVolumeBuyUpload.vue?vue&type=script&lang=js"

import "./MultiVolumeBuyUpload.vue?vue&type=style&index=0&id=bff84c5c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bff84c5c"]])

export default __exports__